import React from 'react'
import { useTranslation } from 'react-i18next'

export interface PictureCountDisplayProps {
  pictureCount: number
}

export const PictureCountDisplay: React.FC<PictureCountDisplayProps> = ({ pictureCount }) => {
  const { t } = useTranslation()

  const getMessage = () => {
    if (pictureCount === 0) {
      return t('wizard.screen.multimedia.webview.modal.pictureCountDisplay.zero', '0 hinzugefügt')
    }

    return t(
      'wizard.screen.multimedia.webview.modal.pictureCountDisplay.multiple',
      '{{count}} hinzugefügt - Klicke auf ein Bild, um es auszuwählen',
      { count: pictureCount }
    )
  }

  return <p className='font-body-small-regular color-text-weak margin-bottom-l margin-top-l'>{getMessage()}</p>
}
